import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Spinner, Pagination, Modal, Form, CloseButton } from "react-bootstrap";
import { connect } from "react-redux";
import Layout from "../../containers/hocs/layout/Layout";
import { RootState } from "../../store";
import { ArrowLeftRight, EraserFill, EyeFill, QrCodeScan } from "react-bootstrap-icons";
import "../../styles/Traslados.css"
import Swal from "sweetalert2";
import { Objeto } from "../Navegacion/Profile";
import { Helmet } from "react-helmet-async";
import Select from "react-select";
import { Html5QrcodeScanner } from "html5-qrcode";
import { comboServicioInformeActions } from "../../redux/actions/Informes/Principal/FolioPorServicioDependencia/comboServicioInformeActions";
import { obtenerInventarioQRActions } from "../../redux/actions/Inventario/obtenerInventarioQRActions";
import { useNavigate } from "react-router-dom";

// Define el tipo de los elementos del combo `Establecimiento`
export interface ESTABLECIMIENTO {
    codigo: number;
    descripcion: string;
}
// Define el tipo de los elementos del combo `traslado servicio`
interface SERVICIO {
    deP_CORR: number;
    descripcion: string;
}

/*-----Tabla principal------*/

/*----Tabla Modal---*/
export interface ListaSeleccion {
    aF_CLAVE: number;
    aF_CODIGO_GENERICO: string;
    altaS_CORR: number;
    seR_NOMBRE: string;
    esP_NOMBRE: string;
    deT_MARCA: string;
    deT_MODELO: string;
    deT_SERIE: string;
    deT_PRECIO: number;
}

interface TrasladosProps {
    obtenerInventarioQRActions: (aF_CODIGO_GENERICO: string) => Promise<boolean>
    listaSeleccion: ListaSeleccion[];
    comboServicioInformeActions: (establ_corr: number) => void;//En buscador 
    comboServicioInforme: SERVICIO[];
    token: string | null;
    isDarkMode: boolean;
    objeto: Objeto;
}

const LevantamientoFisico: React.FC<TrasladosProps> = ({
    obtenerInventarioQRActions,
    comboServicioInformeActions,
    comboServicioInforme,
    listaSeleccion,
    objeto,
    token,
    isDarkMode }) => {
    const [loading, setLoadingScan] = useState(false);
    const [loadingBuscar, _] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [mostrarModalLevantamiento, setMostrarModalLevantamiento] = useState(false);
    const [mostrarModalScan, setMostrarModalScan] = useState(false);
    const [paginaActual, setPaginaActual] = useState(1);
    const [paginaActual1, setPaginaActual1] = useState(1);
    const [filasSeleccionadas, setFilasSeleccionadas] = useState<string[]>([]);
    const [filasSeleccionadasLevantamiento, setfilasSeleccionadasLevantamiento] = useState<string[]>([]);
    const [activosFijos, setActivosFijos] = useState<ListaSeleccion[]>([]);
    const [mostrarScanner, setMostrarScanner] = useState(false);
    const [error, setError] = useState<Partial<any> & {}>({});
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    const navigate = useNavigate();
    const [Paginacion, setPaginacion] = useState({
        nPaginacion: 10
    });
    const elementosPorPagina = Paginacion.nPaginacion;

    const [Paginacion1, setPaginacion1] = useState({
        nPaginacion1: 10
    });
    const elementosPorPagina1 = Paginacion1.nPaginacion1;

    const [Scan, setScan] = useState({
        aF_CODIGO_GENERICO: "",
        seR_CORR: 0,
        deP_CORR_ORIGEN: 0
    });

    const servicioFormOptions = comboServicioInforme.map((item) => ({
        value: item.deP_CORR,
        label: item.descripcion,
    }));

    const handleServicioFormChange = (selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : 0;
        setScan((prev) => ({ ...prev, deP_CORR_ORIGEN: value }));
    };

    const validate = () => {
        let tempErrors: Partial<any> & {} = {};
        if (!Scan.deP_CORR_ORIGEN || Scan.deP_CORR_ORIGEN === 0) tempErrors.deP_CORR_ORIGEN = "Campo obligatorio.";

        setError(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    useEffect(() => {
        if (elementosActuales.length > 0) {
            setFilasSeleccionadas([indicePrimerElemento.toString()]);
        }
        if (token) {
            // Verifica si las acciones ya fueron disparadas
            if (comboServicioInforme.length === 0) comboServicioInformeActions(objeto.Roles[0].codigoEstablecimiento);
        }
    }, [comboServicioInformeActions, comboServicioInforme.length, listaSeleccion]);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        // Validación específica para af_codigo_generico: solo permitir números
        if (name === "aF_CODIGO_GENERICO" && !/^[0-9]*$/.test(value)) {
            return; // Salir si contiene caracteres no numéricos
        }
        // Convierte `value` a número
        let newValue: string | number = ["deP_CORR_ORIGEN", "deP_CORR", "n_TRASLADO", "seR_CORR"].includes(name)
            ? parseFloat(value) || 0 // Convierte a `number`, si no es válido usa 0
            : value;

        setScan((prev) => ({
            ...prev,
            [name]: newValue,
        }));

        setPaginacion((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setPaginacion1((prevState) => ({
            ...prevState,
            [name]: value,
        }));

    };

    /*-------------Tabla Modal-------------------*/
    // const handleSeleccionaTodos = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     if (e.target.checked) {
    //         setFilasSeleccionadas(
    //             elementosActuales.map((_, index) =>
    //                 (indicePrimerElemento + index).toString()
    //             )
    //         );
    //         // console.log("filas Seleccionadas ", filasSeleccionadas);
    //     } else {
    //         setFilasSeleccionadas([]);
    //     }
    // };



    const handleAgregarSeleccionados = async () => {
        const selectedIndices = filasSeleccionadas.map(Number);
        const activosSeleccionados = selectedIndices.map((index) => {
            return {
                aF_CLAVE: listaSeleccion[index].aF_CLAVE,
                aF_CODIGO_GENERICO: listaSeleccion[index].aF_CODIGO_GENERICO,
                altaS_CORR: listaSeleccion[index].altaS_CORR,
                seR_NOMBRE: listaSeleccion[index].seR_NOMBRE,
                esP_NOMBRE: listaSeleccion[index].esP_NOMBRE,
                deT_MARCA: listaSeleccion[index].deT_MARCA,
                deT_MODELO: listaSeleccion[index].deT_MODELO,
                deT_SERIE: listaSeleccion[index].deT_SERIE,
                deT_PRECIO: listaSeleccion[index].deT_PRECIO,

            };
        });

        // const result = await Swal.fire({
        //     icon: "info",
        //     title: "Agregar articulo",
        //     text: `Confirme para agregar`,
        //     showDenyButton: false,
        //     showCancelButton: true,
        //     confirmButtonText: "Confirmar y Agregar",
        //     background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
        //     color: `${isDarkMode ? "#ffffff" : "000000"}`,
        //     confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
        //     customClass: {
        //         popup: "custom-border", // Clase personalizada para el borde
        //     }
        // });

        // Verificar duplicados antes de mostrar la confirmación
        const duplicados = activosSeleccionados.filter(activo =>
            activosFijos.some(existente => existente.aF_CLAVE === activo.aF_CLAVE)
        );

        // if (result.isConfirmed) {
        if (duplicados.length > 0) {
            // Crear la tabla HTML con los duplicados
            const tablaHTML = `
            <div style="max-height: 300px; overflow-y: auto;">
              <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                <thead>
                  <tr style="background-color: ${isDarkMode ? '#333' : '#f5f5f5'};">
                    <th style="padding: 8px; border: 1px solid;  ${isDarkMode ? '#555' : '#ddd'}; text-align: center;">Nº Inventario</th>
                    <th style="padding: 8px; border: 1px solid;  ${isDarkMode ? '#555' : '#ddd'}; text-align: center;">Especie</th>
                  </tr>
                </thead>
                <tbody>
                  ${duplicados.map(item => `
                    <tr>
                      <td style="padding: 8px; border: 1px solid; text-align: center; width: 145px; ${isDarkMode ? '#555' : '#ddd'};">${item.aF_CODIGO_GENERICO}</td>
                      <td style="padding: 8px; border: 1px solid; text-align: center; width: 200px; ${isDarkMode ? '#555' : '#ddd'};">${item.esP_NOMBRE || 'Sin descripción'}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
          `;
            Swal.fire({
                icon: "warning",
                title: "Artículos duplicados",
                html: `<p>Los siguientes artículos ya están agregados:</p>${tablaHTML}`,
                confirmButtonText: "Entendido",
                background: `${isDarkMode ? "#1e1e1e" : "#ffffff"}`,
                color: `${isDarkMode ? "#ffffff" : "#000000"}`,
                confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
                width: '600px',
                customClass: {
                    popup: "custom-border",
                }
            });
            setFilasSeleccionadas([]);
            return;
        } else {
            // Swal.fire({
            //     icon: "success",
            //     title: "Artículos Agregados",
            //     html: `Articulos agregados con exito!`,
            //     confirmButtonText: "Cerrar",
            //     background: `${isDarkMode ? "#1e1e1e" : "#ffffff"}`,
            //     color: `${isDarkMode ? "#ffffff" : "#000000"}`,
            //     confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
            //     width: '600px',
            //     customClass: {
            //         popup: "custom-border",
            //     }
            // });
            setMostrarModal(false);
            setActivosFijos((prev) => [...prev, ...activosSeleccionados]);
            setFilasSeleccionadas([]);
            paginar1(1);
            // setMostrarModal(false);
        }
        // }
    }
    /*-------------Tabla Activos Seleccionados-------------------*/
    const handleSeleccionaTodosLevantamiento = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setfilasSeleccionadasLevantamiento(
                elementosActuales1.map((_, index) =>
                    (indicePrimerElemento1 + index).toString()
                )
            );
            // console.log("filas Seleccionadas ", filasSeleccionadas);
        } else {
            setfilasSeleccionadasLevantamiento([]);
        }
    };

    const setSeleccionaFilasLevantamiento = (index: number) => {
        setfilasSeleccionadasLevantamiento((prev) =>
            prev.includes(index.toString())
                ? prev.filter((rowIndex) => rowIndex !== index.toString())
                : [...prev, index.toString()]
        );
    };

    const handleQuitarSeleccionados = () => {
        // Convertir los índices seleccionados a números
        const selectedIndices = filasSeleccionadasLevantamiento.map(Number);
        // Filtrar los activos y eliminar los seleccionados
        setActivosFijos((prev) => {
            const actualizados = prev.filter((_, index) => !selectedIndices.includes(index));
            return actualizados;
        });
        // Limpiar las filas seleccionadas
        setfilasSeleccionadasLevantamiento([]);
        paginar1(1);
    };

    const handleScan = () => {
        if (validate()) {
            setMostrarModalScan(true);
            setMostrarScanner(true);
        }
    };

    useEffect(() => {
        if (!mostrarScanner) return;
        const scanner = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 }, false);
        scanner.render(
            (decodedText) => {
                // 👉 Aquí manejas el texto escaneado
                setMostrarScanner(false); // Oculta el escáner
                handleScanResult(decodedText);
                scanner.clear().catch(console.error);
            },
            (error) => {
                console.warn("QR no detectado:", error);
            }
        );

        return () => {
            scanner.clear().catch(console.error);
        };

    }, [mostrarScanner]);

    const handleScanResult = async (text: string) => {
        let resultado = false;
        // Extrae el número después de "Cod. Bien:"
        const match = text.match(/Cod\. Bien:\s*(\d+)/);
        const codigoExtraido = match ? match[1] : null;

        if (codigoExtraido) {
            resultado = await obtenerInventarioQRActions(codigoExtraido);
            if (!resultado) {
                Swal.fire({
                    icon: "warning",
                    title: "Sin Resultados",
                    text: "No hay registros disponibles para mostrar.",
                    background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
                    color: `${isDarkMode ? "#ffffff" : "000000"}`,
                    confirmButtonColor: `${isDarkMode ? "#6c757d" : "#0d6efd"}`,
                    customClass: {
                        popup: "custom-border", // Clase personalizada para el borde
                    }
                });
                setMostrarModalScan(false);
                setLoadingScan(false);
            } else {
                paginar(1);
                setMostrarModalScan(false);
                setMostrarModal(true);
                setLoadingScan(false); //Finaliza estado de carga     
            }

        } else {
            console.warn("No se encontró el código en el QR escaneado");
        }
    };

    const handleCerrarModal = () => {
        setMostrarModalScan(false);
        setMostrarScanner(false);
    }

    const handleLimpiar = async () => {
        const result = await Swal.fire({
            icon: "info",
            title: "Limpiar Levantamiento",
            text: "¿Confirma que desea limpiar todo su levantamiento?",
            showCancelButton: true,
            confirmButtonText: "Confirmar y Limpiar",
            background: `${isDarkMode ? "#1e1e1e" : "ffffff"}`,
            color: `${isDarkMode ? "#ffffff" : "000000"}`,
            confirmButtonColor: `#dc3545`,
            customClass: {
                popup: "custom-border", // Clase personalizada para el borde
            }
        });

        if (result.isConfirmed) {
            setActivosFijos([]);

        }

    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        //Limpia
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const HandleVolver = () => {
        navigate("/");
    }
    /*-----------------------Tabla Resultado de busqueda----------------------*/
    // Lógica de Paginación actualizada 
    const indiceUltimoElemento = paginaActual * elementosPorPagina;
    const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina;
    const elementosActuales = useMemo(
        () => listaSeleccion.slice(indicePrimerElemento, indiceUltimoElemento),
        [listaSeleccion, indicePrimerElemento, indiceUltimoElemento]);

    const paginar = (numeroPagina: number) => setPaginaActual(numeroPagina);

    /*-----------------------Tabla Selecciones a Trasladar----------------------*/

    // Lógica de Paginación actualizada 
    const indiceUltimoElemento1 = paginaActual1 * elementosPorPagina1;
    const indicePrimerElemento1 = indiceUltimoElemento1 - elementosPorPagina1;
    const elementosActuales1 = useMemo(
        () => activosFijos.slice(indicePrimerElemento1, indiceUltimoElemento1),
        [activosFijos, indicePrimerElemento1, indiceUltimoElemento1]);

    const totalPaginas1 = Array.isArray(activosFijos)
        ? Math.ceil(activosFijos.length / elementosPorPagina1) : 0;
    const paginar1 = (numeroPagina1: number) => setPaginaActual1(numeroPagina1);

    const dependencia = comboServicioInforme.find(
        (f) => f.deP_CORR === Scan.deP_CORR_ORIGEN
    );
    return (
        <Layout>
            <Helmet>
                <title>Levantamiento Físico</title>
            </Helmet>
            {isMobile ? (
                <>
                    <div className={`border p-2 rounded h-100 vh-100 ${isDarkMode ? "darkModePrincipal border-secondary" : ""}`}>
                        <h3 className="form-title fw-semibold border-bottom p-1 mb-3 text-center">
                            Levantamiento Físico
                        </h3>

                        <Row className="p-1 justify-content-center align-content-around h-75 vh-75">
                            <Col md={4}>
                                <p
                                    className={`text-center px-3 py-2 mb-3 rounded-3 shadow-sm 
                                         ${isDarkMode
                                            ? 'bg-dark text-light border border-secondary'
                                            : 'bg-light text-muted border'}`}
                                >
                                    Para comenzar con su levantamiento, seleccione primero su ubicación actual.
                                </p>
                                {/* Servicio / Dependencia   */}
                                <div className="mb-3 position-relative z-1">
                                    <label className="fw-semibold text-center">Servicio / Dependencia</label>
                                    <Select
                                        options={servicioFormOptions}
                                        onChange={handleServicioFormChange}
                                        name="servicio"
                                        value={
                                            servicioFormOptions.find(
                                                (option) => option.value === Scan.deP_CORR_ORIGEN
                                            ) || null
                                        }
                                        placeholder="Buscar"
                                        className={`form-select-container  ${error.deP_CORR_ORIGEN ? "is-invalid" : ""}`}
                                        classNamePrefix="react-select"
                                        isClearable
                                        isSearchable
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                backgroundColor: isDarkMode ? "#212529" : "white",
                                                color: isDarkMode ? "white" : "#212529",
                                                borderColor: isDarkMode ? "rgb(108 117 125)" : "#a6a6a66e",
                                                borderRadius: "0.8rem",
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: isDarkMode ? "white" : "#212529",
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                backgroundColor: isDarkMode ? "#212529" : "white",
                                                color: isDarkMode ? "white" : "#212529",
                                            }),
                                            option: (base, { isFocused, isSelected }) => ({
                                                ...base,
                                                backgroundColor: isSelected
                                                    ? "#6c757d"
                                                    : isFocused
                                                        ? "#6c757d"
                                                        : isDarkMode
                                                            ? "#212529"
                                                            : "white",
                                                color: isSelected || isFocused || isDarkMode ? "white" : "#212529",
                                            }),
                                        }}
                                    />
                                    {error.deP_CORR_ORIGEN && (
                                        <div className="invalid-feedback fw-semibold d-block">
                                            {error.deP_CORR_ORIGEN}
                                        </div>
                                    )}
                                </div>
                            </Col>

                            <Col md={4}>
                                {/* Botón Escanear */}
                                <div className="d-flex justify-content-center mb-5">
                                    <Button
                                        onClick={handleScan}
                                        variant={isDarkMode ? "secondary" : "primary"}
                                        className="btn w-100 pt-3 pb-3 rounded-3"
                                    >
                                        <div className="d-flex justify-content-center align-items-center">

                                            {loadingBuscar ? (
                                                <Spinner as="span" animation="border" size="sm" className="mx-1" />
                                            ) : (
                                                <QrCodeScan width={18} height={18} className="mx-1" />
                                            )}
                                            <p className="mb-0 me-2">
                                                {elementosActuales1.length > 0 ? "Escanear Otro" : "Escanear"}
                                            </p>
                                        </div>
                                    </Button>
                                </div>
                            </Col>

                            <Col md={4} >
                                {/* Botón Limpiar */}
                                {elementosActuales1.length > 0 && (
                                    <div className="mb-1 mb-1">
                                        <Button
                                            onClick={handleLimpiar}
                                            variant="danger"
                                            className="btn w-100 d-flex justify-content-center align-items-center pt-2 pb-2 rounded-3"
                                        >
                                            <EraserFill className="flex-shrink-0 h-5 w-5 mx-1" aria-hidden="true" />
                                            <p className="mb-0 me-2">Limpiar Todo</p>
                                        </Button>
                                    </div>
                                )}

                                {/* Botón Ver Levantamiento */}
                                {elementosActuales1.length > 0 && (
                                    <div className="mb-5 d-flex justify-content-center">
                                        <Button
                                            onClick={() => setMostrarModalLevantamiento(true)}
                                            variant="success"
                                            className="btn w-100 pt-2 pb-2 rounded-3"
                                        >
                                            <div className="d-flex justify-content-center align-items-center">

                                                {loadingBuscar ? (
                                                    <Spinner as="span" animation="border" size="sm" className="mx-1" />
                                                ) : (
                                                    <EyeFill width={18} height={18} className="mx-1" />
                                                )}
                                                <p className="mb-0 me-2">Levantamientos</p>
                                                <span className="badge bg-light text-dark">
                                                    {activosFijos.length}
                                                </span>

                                            </div>
                                        </Button>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </div>

                    {/* Modal lista seleccion inventarios */}
                    <Modal show={mostrarModal} onHide={() => setMostrarModal(false)}
                        size="lg"
                        dialogClassName="draggable-modal"
                        // scrollable={false}
                        centered
                        backdrop="static" // Evita que se cierre al hacer clic afuera
                        keyboard={false}
                    >
                        <Modal.Header className={`${isDarkMode ? "darkModePrincipal text-light border-secondary" : ""}`} closeButton>
                            <Modal.Title className="fw-semibold">Resultado de Búsqueda</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className={`${isDarkMode ? "darkModePrincipal" : ""}`}>
                            <div className={` border-botom p-2 rounded  ${isDarkMode ? "darkModePrincipal text-light border-secondary" : ""}`}>
                                <Row className="g-2 align-items-center flex-column flex-lg-row justify-content-between">

                                    {/* Botón de agregar */}
                                    <Col xs={12} lg={2} className="d-flex justify-content-center justify-content-lg-end">
                                        <Button
                                            variant={isDarkMode ? "secondary" : "primary"}
                                            onClick={handleAgregarSeleccionados}
                                            className="p-2 w-100 w-sm-auto d-flex align-items-center justify-content-center"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    Agregar
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className="ms-2"
                                                    />
                                                </>
                                            ) : (
                                                <>Agregar</>
                                            )}
                                        </Button>
                                    </Col>

                                    {/* Lista de elementos */}
                                    <Col xs={12} lg={10}>
                                        {elementosActuales.map((fila, index) => (
                                            <Row key={index} className="mb-3 text-center">
                                                <Col>
                                                    {/* Nº Inventario */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Nº Inventario</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            {fila.aF_CODIGO_GENERICO || "Sin Información"}
                                                        </div>
                                                    </div>

                                                    {/* Nº Alta */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Nº Alta</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            {fila.altaS_CORR || "Sin Información"}
                                                        </div>
                                                    </div>

                                                    {/* Servicio/Dependencia */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Servicio/Dependencia</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            {fila.seR_NOMBRE || "Sin Información"}
                                                        </div>
                                                    </div>

                                                    {/* Especie */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Especie</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            {fila.esP_NOMBRE || "Sin Información"}
                                                        </div>
                                                    </div>

                                                    {/* Marca */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Marca</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            {fila.deT_MARCA || "Sin Información"}
                                                        </div>
                                                    </div>

                                                    {/* Modelo */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Modelo</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            {fila.deT_MODELO || "Sin Información"}
                                                        </div>
                                                    </div>

                                                    {/* Serie */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Serie</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            {fila.deT_SERIE || "Sin Información"}
                                                        </div>
                                                    </div>

                                                    {/* Precio */}
                                                    <div className="mb-2">
                                                        <label className="fw-semibold">Precio</label>
                                                        <div
                                                            className={`rounded border px-2 py-1 small fw-medium ${isDarkMode
                                                                ? "bg-dark border-secondary text-light"
                                                                : "bg-light border-muted text-dark"
                                                                }`}
                                                        >
                                                            $  {fila.deT_PRECIO
                                                                ? fila.deT_PRECIO.toLocaleString("es-ES", { minimumFractionDigits: 0 })
                                                                : "Sin Información"}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>

                                        ))}
                                    </Col>
                                </Row>
                            </div>

                        </Modal.Body>
                    </Modal>

                    {/* Modal de bienes levantados */}
                    < Modal show={mostrarModalLevantamiento} onHide={() => setMostrarModalLevantamiento(false)}
                        size="lg"
                        dialogClassName="modal-right"
                        centered
                        backdrop="static"
                    //  keyboard={false}  // Evita el cierre al presionar la tecla Esc
                    >
                        <Modal.Header className={`${isDarkMode ? "darkModePrincipal" : ""}`} closeButton>
                            <Modal.Title className="fw-semibold">
                                Levantamientos: {activosFijos.length}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className={`${isDarkMode ? "darkModePrincipal" : ""}`}>
                            {activosFijos.length === 0 ? (
                                <p className="d-flex justify-content-center m-1 p-1 ">
                                    Seleccione artículos de la búsqueda para incluirlos aquí
                                </p>
                            ) : (
                                <div className={`border p-1 rounded ${isDarkMode ? "darkModePrincipal border-secondary" : ""}`}>
                                    <p className="fw-semibold border-bottom fs-4">{dependencia ? dependencia.descripcion : "—"}</p>
                                    <p className="mb-4 fs-07rem  text-start">(Dependencia del levantamiento) </p>
                                    <Row className="p-1 row justify-content-center ">
                                        <Col xs={12} lg="auto">
                                            {elementosActuales1.length > 10 && (
                                                <div className="d-flex m-1">
                                                    <label htmlFor="nPaginacion" className="form-label fw-semibold mb-0 me-2">
                                                        Tamaño de página:
                                                    </label>
                                                    <select
                                                        aria-label="Seleccionar tamaño de página"
                                                        className={`form-select form-select-sm w-auto rounded-1 ${isDarkMode ? "bg-dark text-light border-secondary" : ""}`}
                                                        name="nPaginacion"
                                                        onChange={handleChange}
                                                        value={Paginacion.nPaginacion}
                                                    >
                                                        {[10, 15, 20, 25, 50, 100].map((val) => (
                                                            <option key={val} value={val}>
                                                                {val}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                        </Col>
                                        <Col md={8}>
                                            <div className="d-flex justify-content-end">
                                                {/* Boton elimina filas seleccionadas */}
                                                {filasSeleccionadasLevantamiento.length > 0 && (
                                                    <Button
                                                        variant="danger"
                                                        onClick={handleQuitarSeleccionados}
                                                        className="mb-1 p-2 mx-1"  // Alinea el spinner y el texto
                                                    >
                                                        <ArrowLeftRight className="flex-shrink-0 h-5 w-5 mx-1 mb-1" aria-hidden="true" />
                                                        {" Quitar "}
                                                        <span className="badge bg-light text-dark mx-1 mb-1">
                                                            {filasSeleccionadasLevantamiento.length}
                                                        </span>
                                                    </Button>
                                                )}
                                            </div>

                                            <div className='table-responsive'>
                                                <table className={`table  ${isDarkMode ? "table-dark" : "table-hover table-striped "}`} >
                                                    <thead className={`sticky-top z-0 ${isDarkMode ? "table-dark" : "text-dark table-light "}`}>
                                                        <tr>
                                                            <th>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    className="text-center"
                                                                    onChange={handleSeleccionaTodosLevantamiento}
                                                                    checked={filasSeleccionadasLevantamiento.length === elementosActuales1.length && elementosActuales1.length > 0}
                                                                />
                                                            </th>
                                                            <th scope="col" className="text-nowrap text-center">Nº Inventario</th>
                                                            <th scope="col" className="text-nowrap text-center">Nº Alta</th>
                                                            <th scope="col" className="text-nowrap text-center">Dependencia	Serv/Depto</th>
                                                            <th scope="col" className="text-nowrap text-center">Especie</th>
                                                            <th scope="col" className="text-nowrap text-center">Marca</th>
                                                            <th scope="col" className="text-nowrap text-center">Modelo</th>
                                                            <th scope="col" className="text-nowrap text-center">Serie</th>
                                                            <th scope="col" className="text-nowrap text-center">Precio</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {elementosActuales1.map((lista, index) => {
                                                            let indexReal = indicePrimerElemento1 + index; // Índice real basado en la página
                                                            return (
                                                                <tr key={indexReal}>
                                                                    <td className="text-center">
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            onChange={() => setSeleccionaFilasLevantamiento(indexReal)}
                                                                            checked={filasSeleccionadasLevantamiento.includes(indexReal.toString())}
                                                                        />
                                                                    </td>
                                                                    <td className="text-nowrap text-center">{lista.aF_CODIGO_GENERICO}</td>
                                                                    <td className="text-nowrap text-center">{lista.altaS_CORR}</td>
                                                                    <td className="text-nowrap text-center">{lista.seR_NOMBRE}</td>
                                                                    <td className="text-nowrap text-center">{lista.esP_NOMBRE}</td>
                                                                    <td className="text-nowrap text-center">{lista.deT_MARCA}</td>
                                                                    <td className="text-nowrap text-center">{lista.deT_MODELO}</td>
                                                                    <td className="text-nowrap text-center">{lista.deT_SERIE}</td>
                                                                    <td className="text-nowrap text-center">{lista.deT_PRECIO.toLocaleString("es-ES", { minimumFractionDigits: 0 })}</td>

                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* Paginador */}
                                            <div className="paginador-container position-relative z-0">
                                                <Pagination className="paginador-scroll ">
                                                    <Pagination.First
                                                        onClick={() => paginar1(1)}
                                                        disabled={paginaActual1 === 1}
                                                    />
                                                    <Pagination.Prev
                                                        onClick={() => paginar1(paginaActual1 - 1)}
                                                        disabled={paginaActual1 === 1}
                                                    />

                                                    {Array.from({ length: totalPaginas1 }, (_, i) => (
                                                        <Pagination.Item
                                                            key={i + 1}
                                                            active={i + 1 === paginaActual1}
                                                            onClick={() => paginar1(i + 1)}
                                                        >
                                                            {i + 1} {/* adentro de aqui esta page-link */}
                                                        </Pagination.Item>
                                                    ))}
                                                    <Pagination.Next
                                                        onClick={() => paginar1(paginaActual1 + 1)}
                                                        disabled={paginaActual1 === totalPaginas1}

                                                    />
                                                    <Pagination.Last
                                                        onClick={() => paginar1(totalPaginas1)}
                                                        disabled={paginaActual1 === totalPaginas1}

                                                    />
                                                </Pagination>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal >

                    {/* Modal para Scaner */}
                    < Modal show={mostrarModalScan} onHide={() => setMostrarModalScan(false)}
                        size="lg"
                        dialogClassName="modal-right"
                        backdrop="static"
                        centered
                    //  keyboard={false}  // Evita el cierre al presionar la tecla Esc
                    >
                        <Modal.Header className={`${isDarkMode ? "darkModePrincipal" : ""}`}>
                            <div className="d-flex justify-content-between w-100">
                                <Modal.Title className="fw-semibold">Escanear QR</Modal.Title>
                                <Button
                                    variant="transparent"
                                    className="border-0"
                                    onClick={handleCerrarModal}
                                >
                                    <CloseButton
                                        aria-hidden="true"
                                        className={"flex-shrink-0 h-5 w-5"}
                                    />
                                </Button>
                            </div>
                        </Modal.Header>
                        <Modal.Body className={`${isDarkMode ? "darkModePrincipal" : ""}`}>
                            {mostrarScanner && (
                                <div
                                    id="reader"
                                    style={{
                                        width: "100%",
                                        maxWidth: "350px",
                                        margin: "0 auto",
                                        background: isDarkMode ? "#222" : "#f8f9fa",
                                        borderRadius: "16px",
                                        border: `2px solid ${isDarkMode ? "#6c757d" : "#0d6efd"}`,
                                        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                                        padding: "24px 12px",
                                        position: "relative",
                                        textAlign: "center"
                                    }}
                                >
                                    {/* Puedes agregar aquí un ícono SVG o de react-bootstrap-icons */}
                                    <div style={{ marginBottom: "12px" }}>
                                        <QrCodeScan size={48} color={isDarkMode ? "#fff" : "#0d6efd"} />
                                    </div>
                                    <div style={{ fontWeight: 500, marginBottom: "8px" }}>
                                        Alinee el código QR dentro del recuadro
                                    </div>
                                    <div style={{ fontSize: "0.95em", color: isDarkMode ? "#ccc" : "#666" }}>
                                        Si no funciona, verifique los permisos de cámara o pruebe subir una imagen.
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                    </Modal >
                </>
            ) : (
                <>
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="col-12 col-md-8 text-center">
                            <h1 className="display-6 mb-4">Recurso no disponible en esta resolución</h1>
                            <p className="fs-5 mb-4">
                                Este módulo ha sido optimizado exclusivamente para dispositivos móviles.
                                Por favor, acceda desde un teléfono o tablet para continuar.
                            </p>
                            <div className="p-4 rounded d-inline-block">
                                <Button onClick={HandleVolver} className={`btn ${isDarkMode ? "btn-secondary" : "btn-primary"} px-4 py-2`}>
                                    Volver
                                </Button>
                            </div>
                        </div>
                    </div>
                </>

            )}
        </Layout >
    );

};

const mapStateToProps = (state: RootState) => ({
    token: state.loginReducer.token,
    comboTrasladoServicio: state.comboTrasladoServicioReducer.comboTrasladoServicio,
    comboEstablecimiento: state.comboEstablecimientoReducer.comboEstablecimiento,
    comboTrasladoEspecie: state.comboTrasladoEspecieReducer.comboTrasladoEspecie,
    comboDependenciaOrigen: state.comboDependenciaOrigenReducer.comboDependenciaOrigen,
    comboDependenciaDestino: state.comboDependenciaDestinoReducer.comboDependenciaDestino,
    listaSeleccion: state.obtenerInventarioQRReducers.listaSeleccion,
    objeto: state.validaApiLoginReducers,
    isDarkMode: state.darkModeReducer.isDarkMode,
    comboEspecies: state.comboEspeciesBienReducers.comboEspecies,
    comboServicioInforme: state.comboServicioInformeReducers.comboServicioInforme,
    listaSalidaTraslados: state.listadoTrasladosReducers.listadoTraslados
});

export default connect(mapStateToProps, {
    comboServicioInformeActions,
    obtenerInventarioQRActions
})(LevantamientoFisico);
